export enum ConfirmLevel {
	Cancel = 1,
	Delete = 2,
	OK = 3
}
